export default async ({ store }) => {
  if (!store.state.program.programData) {
    await store.dispatch('program/getProgram')
  }
}
